import product from '../../../facades/prismic/product';
import { remapLocale } from 'src/common/l10n/country';
import {
  fetchPrismicProductPending,
  fetchPrismicProductSuccess,
  fetchPrismicProductFailure,
} from '../../actions/prismic/product';
import get from 'lodash/get';

export const fetchPrismicProduct = (sku, locale, props) => dispatch => {
  const remappedLocale = remapLocale(locale);
  const prismicProduct = get(props, ['prismicProductLangs', remappedLocale]);

  if (prismicProduct) {
    return Promise.resolve(prismicProduct);
  }

  dispatch(fetchPrismicProductPending(sku, remappedLocale));
  return product
    .get(sku, remappedLocale)
    .then(response =>
      dispatch(fetchPrismicProductSuccess(sku, remappedLocale, response)),
    )
    .catch(error =>
      dispatch(fetchPrismicProductFailure(sku, remappedLocale, error)),
    );
};
